import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { Payee, WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { queriesPayables } from "@query";
import { DataView } from "../../../shared/components/DataView";
import { selectorPayeeDisplayName } from "../../../shared/selectors/selectorPayeeDisplayName";
import { buildPayeeDetailsPath } from "../../Payees/utils";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";
import styles from "./WorkLogAssignmentInfo.module.scss";

type Props = {
  shimmer?: boolean;
  workLog?: WorkLog;
  payee?: Payee;
  payerPayeeEngagement?: IPayeeEngagementResponse;
};

export const WorkLogAssignmentInfoPayerView: React.FC<Props> = props => {
  const history = useHistory();

  // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
  const queryPayable = queriesPayables.getPayable.useQuery(
    { payableId: props.workLog?.convertedResourceId! },
    { enabled: !!props.workLog?.convertedResourceId }
  );

  const statusCellProps = props.workLog
    ? getWorkLogPayerStatusCellProps({
        workLog: props.workLog,
        payable: queryPayable.data
      })
    : undefined;

  const payeeName = props.payee
    ? selectorPayeeDisplayName(props.payee)
    : undefined;
  const payeeId = props.payee?.id;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Engagement name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            secondaryTextColor: statusCellProps?.secondaryTextColor,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          {
            label: "Contractor name",
            value: payeeName && payeeId ? "" : payeeName,
            action:
              payeeName && payeeId
                ? {
                    label: payeeName,
                    onClick: () => history.push(buildPayeeDetailsPath(payeeId)),
                    className: styles.entityLink
                  }
                : undefined
          }
        ]}
      />
    </WSElement>
  );
};
